/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_Document_ReadingInputs */



/**
* | output |
* | --- |
* | "being read" |
*
* @param {Meeting_Sources_Document_ReadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_document_reading = /** @type {((inputs?: Meeting_Sources_Document_ReadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Document_ReadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("wordt gelezen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("en cours de lecture")
	return /** @type {LocalizedString} */ ("being read")
});